import React, {Component} from 'react'
import '../../../styles/Admin.css'
import AdminService from "../AdminService";

export default class ZarzadzanieEventami extends Component {

    constructor(props) {
        super(props);

        this.state = {
            eventy: [],
            loading: true
        }
    }

    componentWillMount() {
        AdminService.getStrony()
            .then(function (response) {
                this.setState({loading: false, eventy: response.data.content})
            }.bind(this)).catch(err => {
            console.log(err)
        })
    }


    checkPublikacja(item) {
        if (item) {
            return <i className={'fa fa-check'} style={{color: '#57b13c'}}> </i>
        } else {
            return <i className={'fa fa-times'} style={{color: 'red'}}> </i>
        }
    }

    renderAkcje(item) {
        return <div>
            <i className="fa fa-trash" aria-hidden="true" style={{paddingLeft: 10}}
               onClick={() => this.deleteItem(item)}> </i>
        </div>
    }

    deleteItem(item) {
        if (window.confirm("Czy na pewno chcesz usunąć stronę eventu?")) {
            AdminService.deleteStrona(item.id)
                .then(function (response) {
                    this.componentWillMount()
                }.bind(this)).catch(err => {
                console.log(err)
            })
        } else {
            return null;
        }
    }

    render() {
        return <div className="aktualnosciTabContainer">
            <div className="aktualnosciOpis">
                Ta zakładka umożliwia zarządzanie istniejącymi eventami. Aby usunąć lub edytować istniejące eventy
                należy wybrać przycisk po prawej stronie danego wpisu.
                Aby dodać nowy event należy przejść do zakładki <span style={{cursor: 'pointer'}}
                                                                      onClick={() => this.props.goNowyWpis()}>
                    <b> dodaj event</b>
                </span>.
            </div>
            <div className="aktualnosciWpisy">
                <div className="row" style={{fontWeight: 'bold', padding: '10px'}}>
                    <div className="col-sm-2">Data dodania</div>
                    <div className="col-sm-7">Tytuł</div>
                    <div className="col-sm-2">Opublikowano</div>
                    <div className="col-sm-1">Akcje</div>
                </div>
                {this.state.loading ? <div>
                    <div className="loaderDim" style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}><i
                        className="fa fa-spinner fa-pulse fa-2x fa-fw"
                        style={{
                            color: '#58b13d'
                        }}> </i></div>
                </div> : <div>
                    {this.state.eventy.length > 0 ? <div>
                        {this.state.eventy.map((item, index) => {
                            if (item.typ === "EVENT") {
                                return <div className="aktualnosciWpis">
                                    <div className="row">
                                        <div className="col-sm-2" onClick={() => {
                                            this.props.setItem(item);
                                            this.props.goEdycja()
                                        }}>{item.dataWpisu}</div>
                                        <div className="col-sm-7" onClick={() => {
                                            this.props.setItem(item);
                                            this.props.goEdycja()
                                        }}>{item.tytul}</div>
                                        <div className="col-sm-2" onClick={() => {
                                            this.props.setItem(item);
                                            this.props.goEdycja()
                                        }}>{this.checkPublikacja(item.aktywny)}</div>
                                        <div className="col-sm-1">{this.renderAkcje(item)}</div>
                                    </div>
                                </div>
                            }
                        })} </div> : <div className="text-center" style={{paddingTop: 15}}>Brak eventów</div>}</div>}
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/eventyComponents/ZarzadzanieEventami.js